import { configureStore } from "@reduxjs/toolkit";
import courseSlice from "./slice/course/courseSlice";
import authSlice from "./slice/auth/authSlice";
import meetingsSlice from "./slice/meetings/meetingsSlice";
import teacherSlotsSlice from "./slice/teacherSlots/teacherSlotsSlice";
import weekDaysSlice from "./slice/weekDays/weekDaysSlice";
import teacherDataSlice from "./slice/teacherData/teacherDataSlice";
import teacherCourseDataSlice from "./slice/teacherCourseData/teacherCourseDataSlice";
import teacherMeetingsSlice from "./slice/teacher-meeting-slice";
import studentMeetingsSlice from "./slice/student-meeting-slice";

export const store = configureStore({
  reducer: {
    courses: courseSlice,
    auth: authSlice,
    userMeetings: meetingsSlice,
    teacherData: teacherDataSlice,
    teacherCourseData: teacherCourseDataSlice,
    weekDays: weekDaysSlice,
    teacherSlots: teacherSlotsSlice,
    teacherMeetings: teacherMeetingsSlice,
    studentMeetings: studentMeetingsSlice,
  },
});
